import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject, Subscription } from "rxjs";

import { AppMemoryService } from "../../core/app-memory.service";
import { AuthService } from "../auth.service";
import { DatePipe } from "@angular/common";
import { GetService } from "../../core/get.service";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { usaRegionBC } from "../../models/Regions";

@Component({
  selector: "app-sign",
  templateUrl: "./sign.component.html",
  styleUrls: ["./sign.component.less"],
})
export class SignComponent implements OnInit, OnDestroy {
  @ViewChild("countrySelector") public countrySelector: any;

  public currentCountry = environment.currentCountry;
  public isAUSCountry = this.currentCountry.toLowerCase() === "aus";

  public serverError = null;
  public form: any;
  public item: any;
  public selectedLang = environment.defaultLanguage;
  // public item2: any;
  // public farms: Farms;
  public countries: any[];
  public regions: any[];
  public showRegionsSelect: boolean = environment.showRegionsSelect;
  public isCountriesLoaded: boolean;
  public isRequestInProgress = false;
  public isRequestSuccess = false;
  public _searchStream = new Subject<any>();
  public loadSuggestion: boolean;
  public countriesSub: Subscription;
  public regionsSub: Subscription;
  public invalidOrganisationName = false;
  public invalidEmail = false;
  public regionSelected = null;

  public datePicker = {
    minDate: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    maxDate: new Date() as Date,
    currentDate: new Date(
      new Date().setFullYear(new Date().getFullYear() - 18)
    ),
    currentDate_input:
      "" /*this.datePipe.transform(new Date().setFullYear(new Date().getFullYear() - 100), environment.dateFormat)*/,
    isActive: false as boolean,
  };

  public farms = {
    name: "" as string,
    add_farm: false,
    completed: false,
    address_first: "" as string,
    address_second: "" as string,
    city: "" as string,
    post_code: "" as string,
    region: "" as string,
    farm: "" as string,
    country_id: null as number,
    show_delete: false,
  };

  public registration = {
    role_id: 1 as number,
    step: 1,
    name: "" as string,
    last_name: "" as string,
    email: "" as string,
    // hri: null as number,
    code: "" as string,
    farm_id: undefined as any,
    farms: [{ ...this.farms }],
    password: "" as string,
    password_confirmation: "" as string,
    agree: 0 as number,
    latitude: "" as string,
    longitude: "" as string,
    birth: "" as string,
    organization_name: undefined as string,
    language: undefined as string,
  };

  public languages = environment.languages || [];

  constructor(
    public router: Router,
    public authService: AuthService,
    public appMemory: AppMemoryService,
    public getService: GetService,
    private datePipe: DatePipe,
    public translate: TranslateService
  ) {
    if (!this.authService.isLocated) {
      this.router.navigateByUrl("/locate");
    }
  }

  ngOnInit() {
    this.countriesSub = this.appMemory.countries.subscribe((countries) => {
      if (countries) {
        countries.forEach((e) => {
          e.text = e.name;
        });

        this.countries = countries;
      }
    });

    this.regionsSub = this.appMemory.regions.subscribe((regions) => {
      if (regions) {
        regions.forEach((e) => {
          e.text = e.name;
        });
        this.regions = regions;
      }
    });
  }

  ngOnDestroy() {
    if (this._searchStream) {
      this._searchStream.unsubscribe();
    }

    if (this.countriesSub) {
      this.countriesSub.unsubscribe();
    }
    if (this.regionsSub) {
      this.regionsSub.unsubscribe();
    }
  }

  resetForm() {
    this.registration.name = "";
    this.registration.last_name = "";
    this.registration.email = "";
    // this.registration.hri = null;
    this.registration.code = "";
    this.registration.farm_id = undefined;
    this.registration.password = "";
    this.registration.password_confirmation = "";
    // this.farms = undefined;
    this.item = undefined;
    // this.item2 = undefined;
  }

  onChangeFarmName(farm) {
    if (!farm.add_farm) {
      farm.add_farm = true;
    }
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.selectedLang = lang;
  }

  openFarm(farm) {
    farm.add_farm = true;
  }

  closeFarm(farm) {
    farm.add_farm = false;
    farm.show_delete = true;
  }

  deleteFarm(key) {
    if (this.registration.farms.length > 1) {
      this.registration.farms.splice(key, 1);
    }
  }

  finishFarm(farm) {
    if (!farm.completed) {
      this.registration.farms.push({ ...this.farms });
      farm.completed = true;
    }
    farm.add_farm = false;
  }

  indexTracker(index: number, value: any) {
    return index;
  }

  setCountryId(e, farm) {
    farm.country_id = e.id;
  }
  setRegionId(e, farm) {
    this.regionSelected = e.id;
    farm.region = e.id;
  }

  setBirthDate(date) {
    this.registration.birth = this.datePipe.transform(date, "yyyy-MM-dd");
    this.datePicker.currentDate = date;
    this.datePicker.currentDate_input = this.datePipe.transform(
      date,
      environment.dateFormat
    );
  }

  public datePickerMask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/],
  };

  formatDate(date) {
    if (date) {
      const arr = date.split("/");
      switch (environment.dateFormat) {
        case "MM/dd/yyyy":
          return arr[0] + "/" + arr[1] + "/" + arr[2];
        case "dd/MM/yyyy":
        default:
          return arr[1] + "/" + arr[0] + "/" + arr[2];
      }
    }
  }

  setBirthDateInput() {
    if (this.serverError) {
      this.serverError.birth = null;
    }
    if (
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() >
      this.datePicker.maxDate.getTime() ||
      new Date(this.formatDate(this.datePicker.currentDate_input)).getTime() <
      this.datePicker.minDate.getTime() ||
      new Date(
        this.formatDate(this.datePicker.currentDate_input)
      ).toDateString() === "Invalid Date"
    ) {
      this.serverError.birth = "CORE.invalidDate";
      return;
    }
    this.datePicker.currentDate = new Date(
      this.formatDate(this.datePicker.currentDate_input)
    );
    this.datePicker.isActive = false;
    this.registration.birth = this.datePipe.transform(
      this.formatDate(this.datePicker.currentDate_input),
      "yyyy-MM-dd"
    );
  }

  removeValidationError(key) {
    if (this.serverError) {
      this.serverError[key] = "";
    }
    if (key === "organization_name") {
      this.invalidOrganisationName = false;
    }
    if (key === "email") {
      this.invalidEmail = true;
      if (
        /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/.test(this.registration.email)
      ) {
        this.invalidEmail = false;
      }
    }
  }

  showPassword(id: string) {
    const el = $(id);
    el.each(function (i: any) {
      el[i].type = "text";
    });
  }

  hidePassword(id: string) {
    const el = $(id);
    el.each(function (i: any) {
      el[i].type = "password";
    });
  }

  ifLoged() {
    $("body").removeClass("modal-open");
    this.router.navigate(["/horses"], {});
    return;
  }

  cancelLogin() {
    this.authService.logout();
    $("body").removeClass("modal-open");
    $("#checkCountry").removeClass("open");
  }

  sendRegistrationConfirm() {
    localStorage.setItem("isConfirm", "true");
    this.authService.isConfirm = true;
    this.sendRegistration();
  }

  sendRegistrationModal(form: any): void {
    this.form = form;
    this.invalidOrganisationName = false;

    if (
      this.registration.role_id === 1 &&
      this.registration.step === 2 &&
      this.form.form.controls.organization_name.invalid
    ) {
      this.invalidOrganisationName = true;
      window.scrollTo(0, 0);
      return;
    }

    if (this.authService.isConfirm) {
      this.sendRegistration();
      return;
    }

    if (this.form.form.invalid) {
      return;
    }

    this.sendRegistrationConfirm();
    // $('body').addClass('modal-open');
    // $('#checkCountry').fadeIn(400).addClass('open');
  }

  sendRegistration() {
    // $('body').removeClass('modal-open');
    // $('#checkCountry').removeClass('open');
    if (this.form.form.invalid) {
      // return;
    }

    this.isRequestInProgress = true;

    let requestOption;
    switch (this.registration.role_id) {
      case 1:
        this.registration.birth = "1970-01-01";
        requestOption = "/trainer";
        break;

      case 2:
        requestOption = "/assistant";
        break;

      case 3:
        requestOption = "/vet";
        break;
    }

    if (this.selectedLang) {
      this.registration.language = this.selectedLang;
    }

    this.getService
      .registerUser(this.registration, requestOption, this.selectedLang)
      .then(
        (res: any) => {
          this.isRequestInProgress = false;
          this.isRequestSuccess = true;
          this.form._submitted = false;
          this.resetForm();
          if (res.access_token) {
            this.authService.login(res.access_token);
            localStorage.setItem("equineLang", res.language);
            if (!localStorage.getItem("showTutorial")) {
              localStorage.setItem("showTutorial", "true");
              this.getService.setShowTutorial(true);
            }
            if (this.regionSelected === usaRegionBC) {
              $("#popup-info").addClass("open").css("display: block");
            }
            if (this.isAUSCountry) {
              $("#termsAndCondition-info").addClass("open").css("display: block");
            }
            this.router.navigate(["/horses"], {});
          } else {
            $("#show_modal_reg_success").trigger("click");
          }
          // show modal
        },
        (err: any) => {
          this.serverError = this._transformErrors(JSON.parse(err._body));
          this.isRequestInProgress = false;
          this.registration.step = 1;
          this.registration.farms.map((value, key) => {
            if (this.registration.farms.length - 1 !== key || key === 0) {
              value.add_farm = true;
            }
          });
        }
      );
  }

  _transformErrors(errors: any) {
    const error = {};
    Object.keys(errors).map((key) => {
      error[key] = errors[key][0];
    });
    return error;
  }

  objectToArray(obj: Object) {
    return Object.keys(obj).map((key) => obj[key]); // transorm Array-like Object to Array
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/sign/sign.component.ts